import { Dispatch } from "redux";
import { AccountAction, GetAccountResponseErrorAction, GetAccountResponseSuccessAction } from "../actions/account";
import { AccountResponses, AccountRoutes } from "../types";
import { getFrom } from "./shared/osfetch";
import { findRoute } from "./util";

const getData = async (next: Dispatch, action: AccountAction) => {
    const response = await getFrom(
        `/accounts/${action.data.account_slug}?expand[address]=*&expand[phone]=*&expand[integration_settings]=*&expand[account_disclaimers]=*&expand[front_end_analytics_config]=*`,
        next
    );

    if (response.ok) {
        const data = await response.json();

        next({
            data,
            type: AccountResponses.GetSuccess,
        } as GetAccountResponseSuccessAction);
    } else {
        const data = await response.json();

        console.error(`Error getting account info for account: ${action.data.account_slug}. Reason: ${data.message}`);

        next({
            account: action.data.account_slug,
            data,
            type: AccountResponses.GetError,
        } as GetAccountResponseErrorAction);
    }
};

const routes = {
    [AccountRoutes.GetAccount]: getData,
};

export default (next: Dispatch, action: any) => findRoute(routes)(next, action);
